import React, { useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	FormControlLabel,
	Checkbox,
	Hidden,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Drawers from '../../components/Drawers';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import flightnotfound from '../../assets/images/flightnotfound.png';
import Login from '../../components/reusableComponents/Login';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import flightpro from '../../assets/images/flightpro.png';
import CardFlight from '../../components/reusableComponents/CardFlight';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlightDetailModal from '../../components/reusableComponents/FlightDetailModal';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import backImg from '../../assets/images/j10.jpg';
import { useDispatch } from 'react-redux';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import flightrun from '../../assets/images/flightrun.png';
import h1 from '../../assets/images/h1.png';
import h2 from '../../assets/images/h2.jpg';
import h3 from '../../assets/images/h3.png';
import h4 from '../../assets/images/h4.png';
import h5 from '../../assets/images/h5.png';
import OnewayForm from '../../form/OneWayFlightForm';
import { useSelector } from 'react-redux';
// import Skeleton from '@material-ui/lab/Skeleton';
import CardFlightReturn from '../../components/reusableComponents/CardFlightReturn';
import { useHistory, useLocation } from 'react-router-dom';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-between',
		},
	},
	searhform: {
		backgroundImage: `url(${backImg})`,
		height: 272,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',

		paddingTop: 124,
		[theme.breakpoints.down('md')]: {
			height: 508,
		},
		[theme.breakpoints.down('xs')]: {
			height: 590,
		},
	},
	radio: {
		'& .MuiTypography-body1': {
			fontSize: 13,
		},
	},
}));

const GreenCheckbox = withStyles({
	root: {
		color: 'rgb(239, 51, 57)',
		'&$checked': {
			color: 'rgb(239, 51, 57)',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const RoundTrip = () => {
	const classes = useStyles();
	const history = useHistory();
	const location = useLocation();
	const [expanded, setExpanded] = React.useState('');
	const [data, setData] = useState('');
	const [scrollVal, SetScrollVal] = useState(10);
	const [scrollVal2, SetScrollVal2] = useState(10);
	const [scrollValResult, SetScrollValResult] = useState(10);
	const [hasMoreresult, SethasMoreResult] = useState(true);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const [hasMorefilterData2, SethasMoreFilterData2] = useState(true);
	const [result, setResult] = useState(null);
	const [result2, setResult2] = useState(null);
	const { flightreturn, loading, roundTripEtrav, orderID } = useSelector(
		(state) => state.home
	);
	const { flightId, RflightId, selectedOrigin, selectedDepart } = useSelector(
		(state) => state.ui
	);
	const [check, setCheck] = useState(false);
	const [check2, setCheck2] = useState(false);
	const [check3, setCheck3] = useState(false);
	const [check4, setCheck4] = useState(false);
	const [rule, SetRule] = useState(false);
	const [check5, setCheck5] = useState(false);
	const [toggle, setToggle] = useState(false);
	const [stop1, setStop1] = useState(false);
	const [stop2, setStop2] = useState(false);
	const [stop3, setStop3] = useState(false);
	const [morning, setMorning] = useState(false);
	const [dophar, setDOphar] = useState(false);
	const [value, setValue] = React.useState([1000, 5000]);
	const handleCheck = (event) => {
		setCheck(event.target.checked);
		console.log(event.target.name);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		let combineflightData1 = [];
		let checkDataTBO1 = [];
		let checkDataEtrav1 = [];
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[0].length > 0 &&
				flightreturn.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO', checkDataTBO);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[0] &&
				roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});

			combineflightData = [...checkDataTBO, ...checkDataEtrav];
			console.log('checkDataTBO', checkDataTBO);
			console.log('checkDataEtrav', checkDataEtrav);
			console.log('combineflightData', combineflightData);
			if (check) {
				setResult(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(combineflightData);
			}
		}
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO1.push({
							...item,
						});
					}
				});
			// console.log('checkDataTBO1', checkDataTBO1);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav1.push({
							...item,
						});
					}
				});

			combineflightData1 = [...checkDataTBO1, ...checkDataEtrav1];
			console.log('checkDataTBO1', checkDataTBO1);
			console.log('checkDataEtrav1', checkDataEtrav1);
			console.log('combineflightData1', combineflightData1);
			if (check) {
				setResult2(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(combineflightData1);
			}
		}
	};
	const handleCheckGO = (event) => {
		setCheck2(event.target.checked);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		let combineflightData1 = [];
		let checkDataTBO1 = [];
		let checkDataEtrav1 = [];
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[0].length > 0 &&
				flightreturn.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO', checkDataTBO);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[0] &&
				roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});

			combineflightData = [...checkDataTBO, ...checkDataEtrav];
			console.log('checkDataTBO', checkDataTBO);
			console.log('checkDataEtrav', checkDataEtrav);
			console.log('combineflightData', combineflightData);
			if (check2) {
				setResult(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(combineflightData);
			}
		}
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO1.push({
							...item,
						});
					}
				});
			// console.log('checkDataTBO1', checkDataTBO1);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav1.push({
							...item,
						});
					}
				});

			combineflightData1 = [...checkDataTBO1, ...checkDataEtrav1];
			console.log('checkDataTBO1', checkDataTBO1);
			console.log('checkDataEtrav1', checkDataEtrav1);
			console.log('combineflightData1', combineflightData1);
			if (check2) {
				setResult2(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(combineflightData1);
			}
		}
	};
	const handleCheckIndigo = (event) => {
		setCheck3(event.target.checked);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		let combineflightData1 = [];
		let checkDataTBO1 = [];
		let checkDataEtrav1 = [];
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[0].length > 0 &&
				flightreturn.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO', checkDataTBO);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[0] &&
				roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});

			combineflightData = [...checkDataTBO, ...checkDataEtrav];
			console.log('checkDataTBO', checkDataTBO);
			console.log('checkDataEtrav', checkDataEtrav);
			console.log('combineflightData', combineflightData);
			if (check3) {
				setResult(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(combineflightData);
			}
		}
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO1.push({
							...item,
						});
					}
				});
			// console.log('checkDataTBO1', checkDataTBO1);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav1.push({
							...item,
						});
					}
				});

			combineflightData1 = [...checkDataTBO1, ...checkDataEtrav1];
			console.log('checkDataTBO1', checkDataTBO1);
			console.log('checkDataEtrav1', checkDataEtrav1);
			console.log('combineflightData1', combineflightData1);
			if (check3) {
				setResult2(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(combineflightData1);
			}
		}
	};
	const handleCheckAir = (event) => {
		setCheck4(event.target.checked);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		let combineflightData1 = [];
		let checkDataTBO1 = [];
		let checkDataEtrav1 = [];
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[0].length > 0 &&
				flightreturn.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO', checkDataTBO);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[0] &&
				roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});

			combineflightData = [...checkDataTBO, ...checkDataEtrav];
			console.log('checkDataTBO', checkDataTBO);
			console.log('checkDataEtrav', checkDataEtrav);
			console.log('combineflightData', combineflightData);
			if (check4) {
				setResult(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(combineflightData);
			}
		}
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO1.push({
							...item,
						});
					}
				});
			// console.log('checkDataTBO1', checkDataTBO1);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav1.push({
							...item,
						});
					}
				});

			combineflightData1 = [...checkDataTBO1, ...checkDataEtrav1];
			console.log('checkDataTBO1', checkDataTBO1);
			console.log('checkDataEtrav1', checkDataEtrav1);
			console.log('combineflightData1', combineflightData1);
			if (check4) {
				setResult2(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(combineflightData1);
			}
		}
	};
	const handleCheckVistara = (event) => {
		setCheck5(event.target.checked);
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		let combineflightData1 = [];
		let checkDataTBO1 = [];
		let checkDataEtrav1 = [];
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[0].length > 0 &&
				flightreturn.result.Response.Results[0].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO', checkDataTBO);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[0] &&
				roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav.push({
							...item,
						});
					}
				});

			combineflightData = [...checkDataTBO, ...checkDataEtrav];
			console.log('checkDataTBO', checkDataTBO);
			console.log('checkDataEtrav', checkDataEtrav);
			console.log('combineflightData', combineflightData);
			if (check5) {
				setResult(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(combineflightData);
			}
		}
		if (flightreturn && roundTripEtrav && event.target.name) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].map((item) => {
					if (item.AirlineCode === event.target.name) {
						checkDataTBO1.push({
							...item,
						});
					}
				});
			// console.log('checkDataTBO1', checkDataTBO1);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.map((item) => {
					if (item.Airline_Code === event.target.name) {
						checkDataEtrav1.push({
							...item,
						});
					}
				});

			combineflightData1 = [...checkDataTBO1, ...checkDataEtrav1];
			console.log('checkDataTBO1', checkDataTBO1);
			console.log('checkDataEtrav1', checkDataEtrav1);
			console.log('combineflightData1', combineflightData1);
			if (check5) {
				setResult2(null);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(combineflightData1);
			}
		}
	};
	const handleOne = () => {
		let combineflightData = [];
		let checkDataTBO = [];
		let checkDataEtrav = [];
		let combineflightData1 = [];
		let checkDataTBO1 = [];
		let checkDataEtrav1 = [];
		if (flightreturn) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[0].length > 0 &&
				flightreturn.result.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 1) {
						checkDataTBO.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO', checkDataTBO);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[0] &&
				roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Segments.length === 1) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
			console.log('checkDataEtrav', checkDataEtrav);
			combineflightData = [...checkDataTBO, ...checkDataEtrav];
			console.log('combineflightData', combineflightData);
			if (stop1) {
				setResult('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(combineflightData);
			}
		}
		if (flightreturn) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].map((item) => {
					if (item.Segments[0].length === 1) {
						checkDataTBO1.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO1', checkDataTBO1);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.map((item) => {
					if (item.Segments.length === 1) {
						checkDataEtrav1.push({
							...item,
						});
					}
				});
			console.log('checkDataEtrav1', checkDataEtrav1);
			combineflightData1 = [...checkDataTBO1, ...checkDataEtrav1];
			console.log('combineflightData1', combineflightData1);
			if (stop1) {
				setResult2('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(combineflightData1);
			}
		}
	};
	const handleTwo = () => {
		let checkDataTBO = [];
		let checkDataEtrav = [];
		let combineFlightData = [];
		let checkDataTBO1 = [];
		let checkDataEtrav1 = [];
		let combineFlightData1 = [];
		if (flightreturn) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[0].length > 0 &&
				flightreturn.result.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 2) {
						checkDataTBO.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO', checkDataTBO);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[0] &&
				roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Segments.length === 2) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
			console.log('checkDataEtrav', checkDataEtrav);
			combineFlightData = [...checkDataTBO, ...checkDataEtrav];
			console.log('CombineFlightData', combineFlightData);
			if (stop2) {
				setResult('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(combineFlightData);
			}
		}
		if (flightreturn) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].map((item) => {
					if (item.Segments[0].length === 2) {
						checkDataTBO1.push({
							...item,
						});
					}
				});
			console.log('checkDataTBO1', checkDataTBO1);
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.map((item) => {
					if (item.Segments.length === 2) {
						checkDataEtrav1.push({
							...item,
						});
					}
				});
			console.log('checkDataEtrav1', checkDataEtrav1);
			combineFlightData1 = [...checkDataTBO1, ...checkDataEtrav1];
			console.log('CombineFlightData1', combineFlightData1);
			if (stop2) {
				setResult2('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(combineFlightData1);
			}
		}
	};
	const handleThree = () => {
		let checkDataTBO = [];
		let checkDataEtrav = [];
		let combineFlightData = [];
		let checkDataTBO1 = [];
		let checkDataEtrav1 = [];
		let combineFlightData1 = [];
		if (flightreturn) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[0].length > 0 &&
				flightreturn.result.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 3) {
						checkDataTBO.push({
							...item,
						});
					}
				});
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[0] &&
				roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[0].Flights.map((item) => {
					if (item.Segments.length === 3) {
						checkDataEtrav.push({
							...item,
						});
					}
				});
			console.log('checkDataEtrav', checkDataEtrav);
			combineFlightData = [...checkDataTBO, ...checkDataEtrav];
			console.log('CombineFlightData', combineFlightData);
			if (stop3) {
				setResult('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(combineFlightData);
			}
		}
		if (flightreturn) {
			flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].map((item) => {
					if (item.Segments[0].length === 3) {
						checkDataTBO1.push({
							...item,
						});
					}
				});
			roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.map((item) => {
					if (item.Segments.length === 3) {
						checkDataEtrav1.push({
							...item,
						});
					}
				});
			console.log('checkDataEtrav1', checkDataEtrav1);
			combineFlightData1 = [...checkDataTBO, ...checkDataEtrav];
			console.log('combineFlightData1', combineFlightData1);
			if (stop3) {
				setResult2('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(combineFlightData1);
			}
		}
	};
	// const [result, setResult] = useState([]);
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const matches2 = useMediaQuery(theme.breakpoints.down('xs'));

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};
	console.log('Location', location);
	let flight = [];
	let Returnflight = [];
	if (loading) {
		console.log('loading.............');
	} else {
		if (flightreturn) {
			flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results &&
				flightreturn.result.Response.Results[0].map((app, index) => {
					if (index === flightId) {
						flight.push({
							...app,
						});
						// dispatch(setFlightData(..app))
					}
				});
		}
		if (flightreturn) {
			flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results &&
				flightreturn.result.Response.Results[1].map((app, index) => {
					if (index === RflightId) {
						Returnflight.push({
							...app,
						});
					}
				});
		}
	}

	let filterData = [];
	filterData =
		flightreturn &&
		flightreturn.result &&
		flightreturn.result.Response &&
		flightreturn.result.Response.Results[0].length > 0 &&
		flightreturn.result.Response.Results[0].slice().sort((a, b) => {
			return a.Fare.OfferedFare - b.Fare.OfferedFare;
		});

	let ReturnfilterData = [];
	ReturnfilterData =
		flightreturn &&
		flightreturn.result &&
		flightreturn.result.Response &&
		flightreturn.result.Response.Results[1].length > 0 &&
		flightreturn.result.Response.Results[1].slice().sort((a, b) => {
			return a.Fare.OfferedFare - b.Fare.OfferedFare;
		});

	let onward = [];
	let returnD = [];
	let combineFlightReturn = [];
	let filterData5 = [];
	if (loading) {
		console.log('Loading.......');
	} else {
		if (
			flightreturn &&
			flightreturn.status === 200 &&
			roundTripEtrav &&
			roundTripEtrav.status === 200
		) {
			let tbo =
				flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1];
			let Etrav =
				roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails &&
				roundTripEtrav.result.TripDetails[1] &&
				roundTripEtrav.result.TripDetails[1].Flights;
			if (Etrav.length > 0 && tbo.length > 0) {
				combineFlightReturn = [...tbo, ...Etrav];
			} else if (tbo.length > 0) {
				combineFlightReturn = [...tbo];
			} else if (Etrav.length > 0) {
				combineFlightReturn = [...Etrav];
			}
			filterData5 =
				combineFlightReturn &&
				combineFlightReturn.length > 0 &&
				combineFlightReturn.slice().sort((a, b) => {
					let first = a.Fare
						? Number(Math.round(a.Fare.Total_Amount))
						: a.Fares
						? Number(
							Math.round(a.Fares.Total_Amount)
						  )
						: Number(Math.round(a.Fare.Total_Amount))
					let second = b.Fare
						? Number(Math.round(b.Fare.Total_Amount))
						: b.Fares
						?  Number(
							Math.round(b.Fares.Total_Amount)
						  )
						: Number(Math.round(b.Fare.Total_Amount))
					return first - second;
				});
			// console.log(filterData5);
		} else if (
			flightreturn &&
			flightreturn.status === 200 &&
			roundTripEtrav &&
			roundTripEtrav.status === 202
		) {
			filterData5 =
				flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].slice().sort((a, b) => {
					let first =
						Number(Math.round(a.Fare.BaseFare)) +
						Number(Math.round(a.Fare.Tax)) +
						Number(Math.round(a.Fare.TdsOnPLB)) +
						Number(Math.round(false ? 0 : a.Fare.agentMarkup)) -
						Number(Math.round(a.Fare.CommissionEarned)) -
						Number(Math.round(a.Fare.PLBEarned)) +
						Number(Math.round(a.Fare.TdsOnCommission)) +
						Number(Math.round(a.Fare.markup)) +
						Number(Math.round(a.Fare.partnerMarkup));
					let second =
						Number(Math.round(b.Fare.BaseFare)) +
						Number(Math.round(b.Fare.Tax)) +
						Number(Math.round(b.Fare.TdsOnPLB)) +
						Number(Math.round(false ? 0 : b.Fare.agentMarkup)) -
						Number(Math.round(b.Fare.CommissionEarned)) -
						Number(Math.round(b.Fare.PLBEarned)) +
						Number(Math.round(b.Fare.TdsOnCommission)) +
						Number(Math.round(b.Fare.markup)) +
						Number(Math.round(b.Fare.partnerMarkup));
					return first - second;
				});
		} else if (
			flightreturn &&
			flightreturn.status === 200 &&
			roundTripEtrav === null
		) {
			filterData5 =
				flightreturn &&
				flightreturn.result &&
				flightreturn.result.Response &&
				flightreturn.result.Response.Results[1].length > 0 &&
				flightreturn.result.Response.Results[1].slice().sort((a, b) => {
					let first =
						Number(Math.round(a.Fare.BaseFare)) +
						Number(Math.round(a.Fare.Tax)) +
						Number(Math.round(a.Fare.TdsOnPLB)) +
						Number(Math.round(false ? 0 : a.Fare.agentMarkup)) -
						Number(Math.round(a.Fare.CommissionEarned)) -
						Number(Math.round(a.Fare.PLBEarned)) +
						Number(Math.round(a.Fare.TdsOnCommission)) +
						Number(Math.round(a.Fare.markup)) +
						Number(Math.round(a.Fare.partnerMarkup));
					let second =
						Number(Math.round(b.Fare.BaseFare)) +
						Number(Math.round(b.Fare.Tax)) +
						Number(Math.round(b.Fare.TdsOnPLB)) +
						Number(Math.round(false ? 0 : b.Fare.agentMarkup)) -
						Number(Math.round(b.Fare.CommissionEarned)) -
						Number(Math.round(b.Fare.PLBEarned)) +
						Number(Math.round(b.Fare.TdsOnCommission)) +
						Number(Math.round(b.Fare.markup)) +
						Number(Math.round(b.Fare.partnerMarkup));
					return first - second;
				});
		} else if (
			roundTripEtrav &&
			roundTripEtrav.status === 200 &&
			flightreturn &&
			flightreturn.status === 202
		) {
			filterData5 =
				roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.slice().sort((a, b) => {
					let first =
						Number(Math.round(a.Fares[0].FareDetails[0].Basic_Amount)) +
						Number(Math.round(a.Fares[0].FareDetails[0].AirportTax_Amount)) -
						Number(Math.round(a.Fares[0].FareDetails[0].Net_Commission)) +
						Number(
							Math.round(false ? 0 : a.Fares[0].FareDetails[0].agentMarkup)
						) +
						Number(Math.round(a.Fares[0].FareDetails[0].TDS)) +
						Number(Math.round(a.Fares[0].FareDetails[0].markup)) +
						Number(Math.round(a.Fares[0].FareDetails[0].partnerMarkup));
					let second =
						Number(Math.round(b.Fares[0].FareDetails[0].Basic_Amount)) +
						Number(Math.round(b.Fares[0].FareDetails[0].AirportTax_Amount)) -
						Number(Math.round(b.Fares[0].FareDetails[0].Net_Commission)) +
						Number(
							Math.round(false ? 0 : b.Fares[0].FareDetails[0].agentMarkup)
						) +
						Number(Math.round(b.Fares[0].FareDetails[0].TDS)) +
						Number(Math.round(b.Fares[0].FareDetails[0].markup)) +
						Number(Math.round(b.Fares[0].FareDetails[0].partnerMarkup));
					return first - second;
				});
		} else if (
			roundTripEtrav &&
			roundTripEtrav.status === 200 &&
			flightreturn === null
		) {
			filterData5 =
				roundTripEtrav &&
				roundTripEtrav.result &&
				roundTripEtrav.result.TripDetails &&
				roundTripEtrav.result.TripDetails[1].Flights.length > 0 &&
				roundTripEtrav.result.TripDetails[1].Flights.slice().sort((a, b) => {
					let first =
						Number(Math.round(a.Fares[0].FareDetails[0].Basic_Amount)) +
						Number(Math.round(a.Fares[0].FareDetails[0].AirportTax_Amount)) -
						Number(Math.round(a.Fares[0].FareDetails[0].Net_Commission)) +
						Number(
							Math.round(false ? 0 : a.Fares[0].FareDetails[0].agentMarkup)
						) +
						Number(Math.round(a.Fares[0].FareDetails[0].TDS)) +
						Number(Math.round(a.Fares[0].FareDetails[0].markup)) +
						Number(Math.round(a.Fares[0].FareDetails[0].partnerMarkup));
					let second =
						Number(Math.round(b.Fares[0].FareDetails[0].Basic_Amount)) +
						Number(Math.round(b.Fares[0].FareDetails[0].AirportTax_Amount)) -
						Number(Math.round(b.Fares[0].FareDetails[0].Net_Commission)) +
						Number(
							Math.round(false ? 0 : b.Fares[0].FareDetails[0].agentMarkup)
						) +
						Number(Math.round(b.Fares[0].FareDetails[0].TDS)) +
						Number(Math.round(b.Fares[0].FareDetails[0].markup)) +
						Number(Math.round(b.Fares[0].FareDetails[0].partnerMarkup));
					return first - second;
				});
		}
	}
	console.log(combineFlightReturn);
	if (loading) {
		console.log('loading.............222');
	} else {
		if (filterData) {
			filterData &&
				filterData.length > 0 &&
				filterData.map((app, index) => {
					if (index === flightId) {
						onward.push({
							...app,
						});
						// dispatch(setFlightData(..app))
					}
				});
		}
		if (ReturnfilterData) {
			ReturnfilterData &&
				ReturnfilterData.length > 0 &&
				ReturnfilterData.map((app, index) => {
					if (index === RflightId) {
						returnD.push({
							...app,
						});
						// dispatch(setFlightData(..app))
					}
				});
		}
	}
	let resultSelection = [];
	let resultRSelection = [];
	if (loading) {
		console.log('loading............');
	} else {
		if (result) {
			result &&
				result.length > 0 &&
				result.map((app, index) => {
					if (index === flightId) {
						resultSelection.push({
							...app,
						});
						// dispatch(setFlightData(..app))
					}
				});
		}
		if (result2) {
			result2 &&
				result2.length > 0 &&
				result2.map((app, index) => {
					if (index === RflightId) {
						resultRSelection.push({
							...app,
						});
						// dispatch(setFlightData(..app))
					}
				});
		}
	}
	console.log('onward', onward);
	console.log('returnD', returnD);
	// console.log('result', resultSelection);
	// console.log('resultR', resultRSelection);
	console.log('flight', flight);
	console.log('Returnflight', Returnflight);
	const fetchMoreData = () => {
		if (scrollVal >= filterData4.length) {
			SethasMoreFilterData(false);
		}
		// a fake async api call like which sends
		// 20 more records in .5 secs
		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
			// this.setState({
			// 	items: this.state.items.concat(Array.from({ length: 20 })),
			// });
		}, 500);
	};
	const fetchMoreData2 = () => {
		if (scrollVal2 >= filterData5.length) {
			SethasMoreFilterData2(false);
		}
		// a fake async api call like which sends
		// 20 more records in .5 secs
		setTimeout(() => {
			SetScrollVal2(scrollVal2 + 5);
			// this.setState({
			// 	items: this.state.items.concat(Array.from({ length: 20 })),
			// });
		}, 500);
	};
	const fetchMoreDataResult = () => {
		if (scrollValResult >= filterData.length) {
			SethasMoreResult(false);
		}
		// a fake async api call like which sends
		// 20 more records in .5 secs
		setTimeout(() => {
			SetScrollValResult(scrollValResult + 5);
			// this.setState({
			// 	items: this.state.items.concat(Array.from({ length: 20 })),
			// });
		}, 500);
	};
	// useEffect(() => {
	// 	dispatch(setFlightData(flight.length == 1 ? flight : ''));
	// 	dispatch(setReturnFlightData(flight.length == 1 ? Returnflight : ''));
	// 	dispatch(setFilterData(flight.length == 1 ? filterData : ''));
	// 	dispatch(setReturnFilterData(flight.length == 1 ? ReturnfilterData : ''));
	// }, [loading]);
	// useEffect(() => {
	// 	if (location.state) {
	// 		dispatch(SearchReturnFormDispatch(location.state.returnBody, history));
	// 	}
	// }, [dispatch]);
	const handlemorning = () => {
		let checkData = [];
		let checkData2 = [];
		if (filterData && filterData.length > 0) {
			filterData &&
				filterData.length > 0 &&
				filterData.map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 5 && b <= 12) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (morning) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}

		if (ReturnfilterData && ReturnfilterData.length > 0) {
			ReturnfilterData &&
				ReturnfilterData.length > 0 &&
				ReturnfilterData.map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 5 && b <= 12) {
						checkData2.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (morning) {
			setResult2([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult2(checkData2);
		}
		console.log('Morning', checkData);
	};
	const handledophar = () => {
		let checkData = [];
		let checkData2 = [];
		if (filterData && filterData.length > 0) {
			filterData &&
				filterData.length > 0 &&
				filterData.map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 12 && b <= 18) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (dophar) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}

		if (ReturnfilterData && ReturnfilterData.length > 0) {
			ReturnfilterData &&
				ReturnfilterData.length > 0 &&
				ReturnfilterData.map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 12 && b <= 18) {
						checkData2.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (dophar) {
			setResult2([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult2(checkData2);
		}
		console.log('Morning', checkData);
	};
	const handleSlider = (event, newValue) => {
		setValue(newValue);
		console.log(newValue);
		let checkData = [];
		let checkData2 = [];
		if (filterData && newValue) {
			filterData &&
				filterData.length > 0 &&
				filterData.map((item) => {
					let a = item.Fare.OfferedFare;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (ReturnfilterData && newValue) {
			ReturnfilterData &&
				ReturnfilterData.length > 0 &&
				ReturnfilterData.map((item) => {
					let a = item.Fare.OfferedFare;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkData2.push({
							...item,
						});
					}
				});
		}

		setResult(checkData);
		setResult2(checkData2);
		SetScrollValResult(10);
		console.log('Slider Value', checkData);
	};
	// console.log(filterData);
	// console.log(ReturnfilterData);

	let combineFlight = [];
	let filterData4 = [];
	if (
		flightreturn &&
		flightreturn.status === 200 &&
		roundTripEtrav &&
		roundTripEtrav.status === 200
	) {
		let tbo =
			flightreturn &&
			flightreturn.result &&
			flightreturn.result.Response &&
			flightreturn.result.Response.Results[0];
		let Etrav =
			roundTripEtrav &&
			roundTripEtrav.result &&
			roundTripEtrav.result.TripDetails &&
			roundTripEtrav.result.TripDetails[0] &&
			roundTripEtrav.result.TripDetails[0].Flights;
		if (Etrav.length > 0 && tbo.length > 0) {
			combineFlight = [...tbo, ...Etrav];
		} else if (tbo.length > 0) {
			combineFlight = [...tbo];
		} else if (Etrav.length > 0) {
			combineFlight = [...Etrav];
		}
		filterData4 =
			combineFlight &&
			combineFlight.length > 0 &&
			combineFlight.slice().sort((a, b) => {
				let first = a.Fare
						? Number(Math.round(a.Fare.Total_Amount))
						: a.Fares
						? Number(
							Math.round(a.Fares.Total_Amount)
						  )
						: Number(Math.round(a.Fare.Total_Amount))
					let second = b.Fare
						? Number(Math.round(b.Fare.Total_Amount))
						: b.Fares
						?  Number(
							Math.round(b.Fares.Total_Amount)
						  )
						: Number(Math.round(b.Fare.Total_Amount))
					return first - second;
			});
	} else if (
		flightreturn &&
		flightreturn.status === 200 &&
		roundTripEtrav &&
		roundTripEtrav.status === 202
	) {
		filterData4 =
			flightreturn &&
			flightreturn.result &&
			flightreturn.result.Response &&
			flightreturn.result.Response.Results[0].length > 0 &&
			flightreturn.result.Response.Results[0].slice().sort((a, b) => {
				let first =
					Number(Math.round(a.Fare.BaseFare)) +
					Number(Math.round(a.Fare.Tax)) +
					Number(Math.round(a.Fare.TdsOnPLB)) +
					Number(Math.round(false ? 0 : a.Fare.agentMarkup)) -
					Number(Math.round(a.Fare.CommissionEarned)) -
					Number(Math.round(a.Fare.PLBEarned)) +
					Number(Math.round(a.Fare.TdsOnCommission)) +
					Number(Math.round(a.Fare.markup)) +
					Number(Math.round(a.Fare.partnerMarkup));
				let second =
					Number(Math.round(b.Fare.BaseFare)) +
					Number(Math.round(b.Fare.Tax)) +
					Number(Math.round(b.Fare.TdsOnPLB)) +
					Number(Math.round(false ? 0 : b.Fare.agentMarkup)) -
					Number(Math.round(b.Fare.CommissionEarned)) -
					Number(Math.round(b.Fare.PLBEarned)) +
					Number(Math.round(b.Fare.TdsOnCommission)) +
					Number(Math.round(b.Fare.markup)) +
					Number(Math.round(b.Fare.partnerMarkup));
				return first - second;
			});
	} else if (
		roundTripEtrav &&
		roundTripEtrav.status === 200 &&
		flightreturn &&
		flightreturn.status === 202
	) {
		filterData4 =
			roundTripEtrav &&
			roundTripEtrav.result &&
			roundTripEtrav.result.TripDetails &&
			roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
			roundTripEtrav.result.TripDetails[0].Flights.slice().sort((a, b) => {
				let first =
					Number(Math.round(a.Fares[0].FareDetails[0].Basic_Amount)) +
					Number(Math.round(a.Fares[0].FareDetails[0].AirportTax_Amount)) -
					Number(Math.round(a.Fares[0].FareDetails[0].Net_Commission)) +
					Number(
						Math.round(false ? 0 : a.Fares[0].FareDetails[0].agentMarkup)
					) +
					Number(Math.round(a.Fares[0].FareDetails[0].TDS)) +
					Number(Math.round(a.Fares[0].FareDetails[0].markup)) +
					Number(Math.round(a.Fares[0].FareDetails[0].partnerMarkup));
				let second =
					Number(Math.round(b.Fares[0].FareDetails[0].Basic_Amount)) +
					Number(Math.round(b.Fares[0].FareDetails[0].AirportTax_Amount)) -
					Number(Math.round(b.Fares[0].FareDetails[0].Net_Commission)) +
					Number(
						Math.round(false ? 0 : b.Fares[0].FareDetails[0].agentMarkup)
					) +
					Number(Math.round(b.Fares[0].FareDetails[0].TDS)) +
					Number(Math.round(b.Fares[0].FareDetails[0].markup)) +
					Number(Math.round(b.Fares[0].FareDetails[0].partnerMarkup));
				return first - second;
			});
	} else if (
		roundTripEtrav === null &&
		flightreturn &&
		flightreturn.status === 200
	) {
		filterData4 =
			flightreturn &&
			flightreturn.result &&
			flightreturn.result.Response &&
			flightreturn.result.Response.Results[0].length > 0 &&
			flightreturn.result.Response.Results[0].slice().sort((a, b) => {
				let first =
					Number(Math.round(a.Fare.BaseFare)) +
					Number(Math.round(a.Fare.Tax)) +
					Number(Math.round(a.Fare.TdsOnPLB)) +
					Number(Math.round(false ? 0 : a.Fare.agentMarkup)) -
					Number(Math.round(a.Fare.CommissionEarned)) -
					Number(Math.round(a.Fare.PLBEarned)) +
					Number(Math.round(a.Fare.TdsOnCommission)) +
					Number(Math.round(a.Fare.markup)) +
					Number(Math.round(a.Fare.partnerMarkup));
				let second =
					Number(Math.round(b.Fare.BaseFare)) +
					Number(Math.round(b.Fare.Tax)) +
					Number(Math.round(b.Fare.TdsOnPLB)) +
					Number(Math.round(false ? 0 : b.Fare.agentMarkup)) -
					Number(Math.round(b.Fare.CommissionEarned)) -
					Number(Math.round(b.Fare.PLBEarned)) +
					Number(Math.round(b.Fare.TdsOnCommission)) +
					Number(Math.round(b.Fare.markup)) +
					Number(Math.round(b.Fare.partnerMarkup));
				return first - second;
			});
	} else if (
		roundTripEtrav &&
		roundTripEtrav.status === 200 &&
		flightreturn === null
	) {
		filterData4 =
			roundTripEtrav &&
			roundTripEtrav.result &&
			roundTripEtrav.result.TripDetails &&
			roundTripEtrav.result.TripDetails[0].Flights.length > 0 &&
			roundTripEtrav.result.TripDetails[0].Flights.slice().sort((a, b) => {
				let first =
					Number(Math.round(a.Fares[0].FareDetails[0].Basic_Amount)) +
					Number(Math.round(a.Fares[0].FareDetails[0].AirportTax_Amount)) -
					Number(Math.round(a.Fares[0].FareDetails[0].Net_Commission)) +
					Number(
						Math.round(false ? 0 : a.Fares[0].FareDetails[0].agentMarkup)
					) +
					Number(Math.round(a.Fares[0].FareDetails[0].TDS)) +
					Number(Math.round(a.Fares[0].FareDetails[0].markup)) +
					Number(Math.round(a.Fares[0].FareDetails[0].partnerMarkup));
				let second =
					Number(Math.round(b.Fares[0].FareDetails[0].Basic_Amount)) +
					Number(Math.round(b.Fares[0].FareDetails[0].AirportTax_Amount)) -
					Number(Math.round(b.Fares[0].FareDetails[0].Net_Commission)) +
					Number(
						Math.round(false ? 0 : b.Fares[0].FareDetails[0].agentMarkup)
					) +
					Number(Math.round(b.Fares[0].FareDetails[0].TDS)) +
					Number(Math.round(b.Fares[0].FareDetails[0].markup)) +
					Number(Math.round(b.Fares[0].FareDetails[0].partnerMarkup));
				return first - second;
			});
	}
	console.log('comibineFlight', combineFlight);
	let selectedonward = [];
	let selectedReturn = [];
	if (loading) {
		console.log('loading.............222');
	} else {
		if (filterData4) {
			filterData4 &&
				filterData4.length > 0 &&
				filterData4.map((app, index) => {
					if (index === flightId) {
						selectedonward.push({
							...app,
						});
					}
				});
		}
		if (filterData5) {
			filterData5 &&
				filterData5.length > 0 &&
				filterData5.map((app, index) => {
					if (index === RflightId) {
						selectedReturn.push({
							...app,
						});
						// dispatch(setFlightData(..app))
					}
				});
		}
	}
	console.log('selectedonward', selectedonward);
	console.log('selectedReturn', selectedReturn);
	console.log('FILTERDATA5', filterData5);
	console.log('filterData4', filterData4);
	// console.log(scrollVal);
	console.log('rESULT', result);
	return (
		<>
			<HeaderSection id={1} />
			{toggle ? (
				<Box
					styel={{ transition: 'all 0.5s ease' }}
					className={classes.searhform}>
					<Container>{/* <OnewayForm /> */}</Container>
				</Box>
			) : (
				''
			)}

			<Box mt={'60px'} style={{ padding: 15 }}>
				{/* <Container> */}
				<Box
					display='flex'
					justifyContent='space-between'
					alignItems='center'
					style={{
						textAlign: 'justify',
						border: '1px solid #d7d7d7',
						padding: 10,
						background:
							'linear-gradient(45deg, rgb(12 31 235), rgb(255 41 41 / 94%))',
					}}>
					<Grid container alignItems='center'>
						<Grid item xs={12} lg={4}>
							{' '}
							<Box>
								<Box
									display='flex'
									alignItems='center'
									style={{ color: 'white' }}>
									{/* <h4>{selectedOrigin.city_name}</h4> */}
									<h4 style={{ marginLeft: 5 }}>
										({selectedOrigin.airport_code})
									</h4>
									<h4 style={{ marginLeft: 5 }}>-</h4>
									{/* <h4 style={{ marginLeft: 5 }}>{selectedDepart.city_name}</h4> */}
									<h4 style={{ marginLeft: 5 }}>
										({selectedDepart.airport_code})
									</h4>
									<h4 style={{ marginLeft: 10 }}>|</h4>
									{/* <h4 style={{ marginLeft: 5 }}>{selectedDepart.city_name}</h4> */}
									<h4 style={{ marginLeft: 5 }}>
										({selectedDepart.airport_code})
									</h4>
									<h4 style={{ marginLeft: 5 }}>-</h4>
									{/* <h4>{selectedOrigin.city_name}</h4> */}
									<h4 style={{ marginLeft: 5 }}>
										({selectedOrigin.airport_code})
									</h4>
								</Box>
								<Box display='flex'>
									<h5 style={{ color: 'white' }}>
										{location.state.returnBody.AdultCount} Adult
									</h5>
									<h5 style={{ marginLeft: 5, color: 'white' }}>
										{location.state.returnBody.ChildCount} Child
									</h5>
									<h5 style={{ marginLeft: 5, color: 'white' }}>
										{location.state.returnBody.InfantCount} Infant
									</h5>
									<h5 style={{ marginLeft: 5, color: 'white' }}>ECONOMY</h5>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12} lg={4}>
							<Box
								// display='flex'
								alignItems='center'
								style={{
									textAlign: 'center',
									color: 'wheat',
									// border: '1px solid rgb(239, 51, 57)',
									// paddingLeft: '10px',
									// paddingRight: '10px',
									// borderRadius: '11px',
								}}>
								{/* <Box display='flex' alignItems='center'>
								<h3>{location.state.body.Segments[0].Origin}</h3>
								<h3>-</h3>
								<h3>{location.state.body.Segments[0].Destination}</h3>
							</Box> */}
								{/* <h4 style={{ marginLeft: 10 }}>
									{`${new Date(
										location.state.body.Segments[0].PreferredDepartureTime
									).toLocaleString('en-us', {
										weekday: 'short',
									})} ,  ${new Date(
										location.state.body.Segments[0].PreferredDepartureTime
									).getDate()} ${new Date(
										location.state.body.Segments[0].PreferredDepartureTime
									).toLocaleString('en-us', {
										month: 'short',
									})},2022`}
								</h4> */}
								<h6>
									{Number(filterData5.length) + Number(filterData4.length)}{' '}
									Flights Found
								</h6>
							</Box>
						</Grid>
						<Hidden only={['xs']}>
							<Grid item xs={2} lg={2}></Grid>
						</Hidden>

						<Grid item xs={12} lg={2}>
							<Box
								style={{
									cursor: 'pointer',
									textAlign: 'center',
									padding: '0.8rem 0.8rem',
									border: '1px solid white',
									background: 'linear-gradient(45deg,rgb(239 51 57),#ffaa40)',
								}}
								onClick={() => (toggle ? setToggle(false) : setToggle(true))}>
								<TitleText textStyle={{ color: 'white', fontSize: 18 }}>
									Modify Search
								</TitleText>
							</Box>
						</Grid>
					</Grid>
				</Box>
				{loading ? (
					<marquee direction='right'>
						<img
							src={flightrun}
							style={{ width: 100, height: 32, marginTop: 10 }}
						/>
					</marquee>
				) : (
					<Box className={classes.accodin}>
						<Accordion
							square
							expanded={expanded === 'panel1'}
							onChange={handleChange('panel1')}>
							<AccordionSummary
								aria-controls='panel1d-content'
								id='panel1d-header'>
								<Box alignItems='center'>
									{/* <i class='fas fa-user'></i> */}
									<TitleText
										three
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										Filter
									</TitleText>
								</Box>
								<Hidden only={['xs']}>
									<Box display='flex' alignItems='center'>
										<TitleText
											three
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											STOPS
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											three
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											PRICE
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											three
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											AIRLINE
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											three
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											DEPARTURE TIME
										</TitleText>
										<ExpandMoreIcon />
									</Box>
								</Hidden>
								<Box display='flex'>
									<TitleText
										three
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										RESET ALL
									</TitleText>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								<Grid container>
									<Grid item xs={12} lg={3}>
										<Box display={'flex'} style={{ padding: 10 }}>
											<Box
												onClick={() => {
													handleOne();
													stop1 ? setStop1(false) : setStop1(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop1 ? 'rgb(239, 51, 57)' : '#eee',
													color: stop1 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													cursor: 'pointer',
												}}>
												<BodyText four>0</BodyText>
											</Box>
											<Box
												onClick={() => {
													handleTwo();
													stop2 ? setStop2(false) : setStop2(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop2 ? 'rgb(239, 51, 57)' : '#eee',
													color: stop2 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText four>1</BodyText>
											</Box>
											<Box
												onClick={() => {
													handleThree();
													stop3 ? setStop3(false) : setStop3(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop3 ? 'rgb(239, 51, 57)' : '#eee',
													color: stop3 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText four>2</BodyText>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={12} lg={3}>
										{/* <Box display='flex'> */}
										<Box
											style={
												{
													// maxWidth: 300,
													// display: 'flex',
												}
											}>
											<Slider
												style={{ maxWidth: 500, color: 'rgb(239, 51, 57)' }}
												value={value}
												min={1000}
												// step={1}
												max={10000}
												aria-label='Default'
												// valueLabelFormat={numFormatter}
												// marks={followersMarks}
												// scale={scaleValues}
												onChange={handleSlider}
												valueLabelDisplay='auto'
												aria-labelledby='non-linear-slider'
											/>
											<Box display='flex' justifyContent='space-between'>
												<BodyText four>Min: {value[0]}</BodyText>
												<BodyText four>Max: {value[1]}</BodyText>
											</Box>
										</Box>
										{/* </Box> */}

										{/* </Box> */}
									</Grid>
									<Grid item xs={12} lg={3}>
										<Box
											ml={'20px'}
											mt={matches ? '20px' : ''}
											className={classes.radio}>
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check}
														onChange={handleCheck}
														name='SG'
													/>
												}
												label='SpiceJet'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check2}
														onChange={handleCheckGO}
														name='G8'
													/>
												}
												label='GO FIRST'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check3}
														onChange={handleCheckIndigo}
														name='6E'
													/>
												}
												label='Indigo'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check4}
														onChange={handleCheckAir}
														name='AI'
													/>
												}
												label='Air Asia'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check5}
														onChange={handleCheckVistara}
														name='UK'
													/>
												}
												label='Vistara'
											/>
											<br />
											{/* - */}
										</Box>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Box display='flex' mt={matches ? '20px' : ''}>
											<Box
												onClick={() => {
													handlemorning();
													morning ? setMorning(false) : setMorning(true);
												}}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													background: morning ? 'rgb(239, 51, 57)' : '#8f8f8f',
													color: morning ? 'white' : '',
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													cursor: 'pointer',
													// background: '#8f8f8f',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText two textStyle={{ color: 'white' }}>
														05-12
													</BodyText>
												</Box>
											</Box>
											<Box
												onClick={() => {
													handledophar();
													dophar ? setDOphar(false) : setDOphar(true);
												}}
												ml={'10px'}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													cursor: 'pointer',
													background: dophar ? 'rgb(239, 51, 57)' : '#8f8f8f',
													color: dophar ? 'white' : '',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText two textStyle={{ color: 'white' }}>
														12-18
													</BodyText>
												</Box>
											</Box>
											{/* <Box
												ml={'10px'}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													background: '#8f8f8f',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText one textStyle={{ color: 'white' }}>
														05-12
													</BodyText>
												</Box>
											</Box>
											<Box
												ml={'10px'}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													background: '#8f8f8f',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText one textStyle={{ color: 'white' }}>
														05-12
													</BodyText>
												</Box>
											</Box> */}
										</Box>
									</Grid>
								</Grid>
							</AccordionDetails>
						</Accordion>
					</Box>
				)}
				<Grid
					container
					style={{ marginTop: 20, marginBottom: 140 }}
					spacing={2}>
					<Grid item xs={12} sm={6} lg={7}>
						<Grid container spacing={4}>
							<Hidden only={['xs', 'sm', 'md']}>
								<Grid item lg={4}>
									<Box mt={'10px'}>
										<img src={h1} width='100%' height='216px'></img>
									</Box>
									<Box mt={'10px'}>
										<img src={h4} width='100%' height='216px'></img>
									</Box>
									<Box mt={'10px'}>
										<img src={h3} width='100%' height='216px'></img>
									</Box>
									<Box mt={'10px'}>
										<img src={h4} width='100%' height='216px'></img>
									</Box>
									<Box mt={'10px'}>
										<img src={h5} width='100%' height='216px'></img>
									</Box>
								</Grid>
							</Hidden>

							<Grid item xs={12} lg={8}>
								<Box
									display='flex'
									justifyContent='space-between'
									style={{
										background: '#eee',
										padding: '10px',
										borderBottom: '1px solid #ddd',
										margin: '0 0 15px',
									}}>
									<Box>
										<TitleText two textStyle={{ color: '#666' }}>
											DEPART
										</TitleText>
									</Box>
									<Box>
										<TitleText two textStyle={{ color: '#666' }}>
											ARRIVAL
										</TitleText>
									</Box>
									<Box>
										<TitleText two textStyle={{ color: '#666' }}>
											PRICE(Per Adult)
										</TitleText>
									</Box>
								</Box>
								<Box
									display='flex'
									justifyContent='space-between'
									style={{ padding: '5px', background: '#39c9bb' }}>
									<Box>
										{loading ? (
											<Skeleton variant='text' width='150px' />
										) : (
											<TitleText three textStyle={{ color: 'white' }}>
												{`${location.state.returnBody.Segments[0].Origin} - ${location.state.returnBody.Segments[0].Destination}`}
											</TitleText>
										)}
										{loading ? (
											<Skeleton variant='text' />
										) : (
											<TitleText two textStyle={{ color: 'white' }}>
												{
													location.state.returnBody.Segments[0]
														.PreferredDepartureTime
												}
											</TitleText>
										)}
									</Box>
									{/* <Box display='flex'>
											<TitleText two>Prev</TitleText>
											<TitleText two>Next</TitleText>
										</Box> */}
								</Box>
								{/* <Box
										style={{
											padding: 10,
											boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
											background: 'rgba(57,201,187,.14)',
											border: '1px solid #39c9bb',
											color: '#666',
										}}>
										<Box display='flex' justifyContent='space-between'>
											<Box display='flex' alignItems='center'>
												<img src={spice} width='50px' height='25px'></img>
												<Box alignItems='center' ml={'5px'}>
													<TitleText two>SpiceJet</TitleText>
													<BodyText two>SG-2589</BodyText>
												</Box>
											</Box>
											<Box display='flex' alignItems='center'>
												<TitleText>Rs 8054</TitleText>
												<MoreVertIcon />
											</Box>
										</Box>
										<Box
											display='flex'
											justifyContent='space-between'
											alignItems='center'>
											<Box>
												<TitleText two>DEL</TitleText>
												<TitleText two>16:40</TitleText>
											</Box>
											<Box alignItems='center' textAlign='center'>
												<TitleText two>1hr 40mins</TitleText>
												<TitleText one>Non Stop</TitleText>
											</Box>
											<Box>
												<TitleText two>AMD</TitleText>
												<TitleText two>19:40</TitleText>
											</Box>
										</Box>
									</Box> */}
								{/* <Box
										style={{
											padding: '6px 10px',
											background: '#f5f6f6',
											borderBottomLeftRadius: '4px',
											borderBottomRightRadius: '4px',
											borderTop: '1px solid #e2e2e2',
											color: '#666',
										}}>
										<Box
											justifyContent='end'
											alignItems='center'
											display='flex'>
											<Box
												onClick={() => dispatch(toggleFlightModal(true))}
												display='flex'>
												<TitleText two>Flight Details</TitleText>
												<ArrowDropDownIcon />
											</Box>
										</Box>
									</Box> */}
								{/* {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => {
										return <CardFlight />;
									})} */}
								{loading ? (
									<>
										<Box
											style={{
												padding: 10,
												boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
											}}>
											<Box display='flex' justifyContent='space-between'>
												<Box display='flex' alignItems='center'>
													<Skeleton variant='circular' width={40} height={40} />
													<Box alignItems='center' ml={'5px'}>
														<Skeleton variant='text' width='100px' />
														<Skeleton variant='text' />
													</Box>
												</Box>
												<Box alignItems='center' display='flex'>
													<Skeleton variant='text' width='50px' />
												</Box>
											</Box>
											<Box
												display='flex'
												justifyContent='space-between'
												alignItems='center'>
												<Box>
													<Skeleton variant='text' width='50px' />
													<Skeleton variant='text' width='50px' />
												</Box>
												<Box alignItems='center' textAlign='center'>
													<Skeleton variant='text' width='50px' />

													<Skeleton variant='text' width='50px' />
												</Box>
												<Box>
													<Skeleton variant='text' width='50px' />
													<Skeleton variant='text' width='50px' />
												</Box>
											</Box>
										</Box>
										<Box
											mt={'5px'}
											style={{
												padding: 10,
												boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
											}}>
											<Box display='flex' justifyContent='space-between'>
												<Box display='flex' alignItems='center'>
													<Skeleton variant='circular' width={40} height={40} />
													<Box alignItems='center' ml={'5px'}>
														<Skeleton variant='text' width='100px' />
														<Skeleton variant='text' />
													</Box>
												</Box>
												<Box alignItems='center' display='flex'>
													<Skeleton variant='text' width='50px' />
												</Box>
											</Box>
											<Box
												display='flex'
												justifyContent='space-between'
												alignItems='center'>
												<Box>
													<Skeleton variant='text' width='50px' />
													<Skeleton variant='text' width='50px' />
												</Box>
												<Box alignItems='center' textAlign='center'>
													<Skeleton variant='text' width='50px' />

													<Skeleton variant='text' width='50px' />
												</Box>
												<Box>
													<Skeleton variant='text' width='50px' />
													<Skeleton variant='text' width='50px' />
												</Box>
											</Box>
										</Box>
										<Box
											mt={'5px'}
											style={{
												padding: 10,
												boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
											}}>
											<Box display='flex' justifyContent='space-between'>
												<Box display='flex' alignItems='center'>
													<Skeleton variant='circular' width={40} height={40} />
													<Box alignItems='center' ml={'5px'}>
														<Skeleton variant='text' width='100px' />
														<Skeleton variant='text' />
													</Box>
												</Box>
												<Box alignItems='center' display='flex'>
													<Skeleton variant='text' width='50px' />
												</Box>
											</Box>
											<Box
												display='flex'
												justifyContent='space-between'
												alignItems='center'>
												<Box>
													<Skeleton variant='text' width='50px' />
													<Skeleton variant='text' width='50px' />
												</Box>
												<Box alignItems='center' textAlign='center'>
													<Skeleton variant='text' width='50px' />

													<Skeleton variant='text' width='50px' />
												</Box>
												<Box>
													<Skeleton variant='text' width='50px' />
													<Skeleton variant='text' width='50px' />
												</Box>
											</Box>
										</Box>
									</>
								) : result && result.length > 0 ? (
									<>
										<InfiniteScroll
											dataLength={scrollValResult}
											next={fetchMoreDataResult}
											hasMore={hasMoreresult}
											loader={<h4>Loading...</h4>}
											endMessage={
												<p style={{ textAlign: 'center' }}>
													<b>No More Data</b>
												</p>
											}>
											{result.map((item, index) => {
												return index < scrollValResult ? (
													<CardFlight item={item} index={index} />
												) : (
													''
												);
											})}
										</InfiniteScroll>
									</>
								) : filterData4 && filterData4.length > 0 ? (
									<InfiniteScroll
										dataLength={scrollVal}
										next={fetchMoreData}
										hasMore={hasMorefilterData}
										loader={<h4>Loading...</h4>}
										endMessage={
											<p style={{ textAlign: 'center' }}>
												<b>No More Data</b>
											</p>
										}>
										{filterData4.map((item, index) => {
											return index < scrollVal ? (
												<CardFlight
													item={item}
													index={index}
													selectedReturn={selectedonward}
												/>
											) : (
												''
											);
										})}
										{/* <></> */}
									</InfiniteScroll>
								) : (
									<>
										<div
											style={{
												padding: '30px 15px',
												background: 'white',
												borderBottom: '1px solid #e6e6e6',
												textAlign: 'center',
											}}>
											<img src={flightnotfound}></img>
											<p style={{ fontSize: '24px', textAlign: 'center' }}>
												No Flight Found
											</p>
										</div>
									</>
								)}
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} sm={6} lg={5}>
						<Box
							display='flex'
							justifyContent='space-between'
							style={{
								background: '#eee',
								padding: '10px',
								borderBottom: '1px solid #ddd',
								margin: '0 0 15px',
							}}>
							<Box>
								<TitleText two textStyle={{ color: '#666' }}>
									DEPART
								</TitleText>
							</Box>
							<Box>
								<TitleText two textStyle={{ color: '#666' }}>
									ARRIVAL
								</TitleText>
							</Box>
							<Box>
								<TitleText two textStyle={{ color: '#666' }}>
									PRICE(Per Adult)
								</TitleText>
							</Box>
						</Box>
						<Box
							display='flex'
							justifyContent='space-between'
							style={{ padding: '5px', background: '#39c9bb' }}>
							<Box>
								{loading ? (
									<Skeleton variant='text' width='150px' />
								) : (
									<TitleText three textStyle={{ color: 'white' }}>
										{`${location.state.returnBody.Segments[1].Origin} - ${location.state.returnBody.Segments[1].Destination}`}
									</TitleText>
								)}
								{loading ? (
									<Skeleton variant='text' />
								) : (
									<TitleText two textStyle={{ color: 'white' }}>
										{
											location.state.returnBody.Segments[1]
												.PreferredDepartureTime
										}
									</TitleText>
								)}
							</Box>
							{/* <Box display='flex' alignItems='center'>
									<TitleText twp>Prev</TitleText>
									<TitleText two>Next</TitleText>
								</Box> */}
						</Box>
						{/* <Box
								style={{
									padding: 10,
									boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
									background: 'rgba(57,201,187,.14)',
									border: '1px solid #39c9bb',
									color: '#666',
								}}>
								<Box display='flex' justifyContent='space-between'>
									<Box display='flex' alignItems='center'>
										<img src={spice} width='50px' height='25px'></img>
										<Box alignItems='center' ml={'5px'}>
											<TitleText two>SpiceJet</TitleText>
											<BodyText two>SG-2589</BodyText>
										</Box>
									</Box>
									<Box alignItems='center' display='flex'>
										<TitleText>Rs 8054</TitleText>
										<MoreVertIcon />
									</Box>
								</Box>
								<Box
									display='flex'
									justifyContent='space-between'
									alignItems='center'>
									<Box>
										<TitleText two>DEL</TitleText>
										<TitleText two>16:40</TitleText>
									</Box>
									<Box alignItems='center' textAlign='center'>
										<TitleText two>1hr 40mins</TitleText>
										<TitleText one>Non Stop</TitleText>
									</Box>
									<Box>
										<TitleText two>AMD</TitleText>
										<TitleText two>19:40</TitleText>
									</Box>
								</Box>
							</Box> */}
						{/* <Box
								style={{
									padding: '6px 10px',
									background: '#f5f6f6',
									borderBottomLeftRadius: '4px',
									borderBottomRightRadius: '4px',
									borderTop: '1px solid #e2e2e2',
									color: '#666',
								}}>
								<Box justifyContent='end' alignItems='center' display='flex'>
									<Box
										onClick={() => dispatch(toggleFlightModal(true))}
										display='flex'>
										<TitleText two>Flight Details</TitleText>
										<ArrowDropDownIcon />
									</Box>
								</Box>
							</Box> */}
						{/* {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => {
								return <CardFlight />;
							})} */}
						{loading ? (
							<>
								<Box
									style={{
										padding: 10,
										boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
									}}>
									<Box display='flex' justifyContent='space-between'>
										<Box display='flex' alignItems='center'>
											<Skeleton variant='circular' width={40} height={40} />
											<Box alignItems='center' ml={'5px'}>
												<Skeleton variant='text' width='100px' />
												<Skeleton variant='text' />
											</Box>
										</Box>
										<Box alignItems='center' display='flex'>
											<Skeleton variant='text' width='50px' />
										</Box>
									</Box>
									<Box
										display='flex'
										justifyContent='space-between'
										alignItems='center'>
										<Box>
											<Skeleton variant='text' width='50px' />
											<Skeleton variant='text' width='50px' />
										</Box>
										<Box alignItems='center' textAlign='center'>
											<Skeleton variant='text' width='50px' />

											<Skeleton variant='text' width='50px' />
										</Box>
										<Box>
											<Skeleton variant='text' width='50px' />
											<Skeleton variant='text' width='50px' />
										</Box>
									</Box>
								</Box>
								<Box
									mt={'5px'}
									style={{
										padding: 10,
										boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
									}}>
									<Box display='flex' justifyContent='space-between'>
										<Box display='flex' alignItems='center'>
											<Skeleton variant='circular' width={40} height={40} />
											<Box alignItems='center' ml={'5px'}>
												<Skeleton variant='text' width='100px' />
												<Skeleton variant='text' />
											</Box>
										</Box>
										<Box alignItems='center' display='flex'>
											<Skeleton variant='text' width='50px' />
										</Box>
									</Box>
									<Box
										display='flex'
										justifyContent='space-between'
										alignItems='center'>
										<Box>
											<Skeleton variant='text' width='50px' />
											<Skeleton variant='text' width='50px' />
										</Box>
										<Box alignItems='center' textAlign='center'>
											<Skeleton variant='text' width='50px' />

											<Skeleton variant='text' width='50px' />
										</Box>
										<Box>
											<Skeleton variant='text' width='50px' />
											<Skeleton variant='text' width='50px' />
										</Box>
									</Box>
								</Box>
								<Box
									mt={'5px'}
									style={{
										padding: 10,
										boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
									}}>
									<Box display='flex' justifyContent='space-between'>
										<Box display='flex' alignItems='center'>
											<Skeleton variant='circular' width={40} height={40} />
											<Box alignItems='center' ml={'5px'}>
												<Skeleton variant='text' width='100px' />
												<Skeleton variant='text' />
											</Box>
										</Box>
										<Box alignItems='center' display='flex'>
											<Skeleton variant='text' width='50px' />
										</Box>
									</Box>
									<Box
										display='flex'
										justifyContent='space-between'
										alignItems='center'>
										<Box>
											<Skeleton variant='text' width='50px' />
											<Skeleton variant='text' width='50px' />
										</Box>
										<Box alignItems='center' textAlign='center'>
											<Skeleton variant='text' width='50px' />

											<Skeleton variant='text' width='50px' />
										</Box>
										<Box>
											<Skeleton variant='text' width='50px' />
											<Skeleton variant='text' width='50px' />
										</Box>
									</Box>
								</Box>
							</>
						) : // ) : ReturnfilterData && ReturnfilterData.length > 0 ? (
						// 	ReturnfilterData.map((item, index) => {
						// 		return <CardFlightReturn item={item} index={index} />;
						// 	})CND4235JQ2
						result2 && result2.length > 0 ? (
							<InfiniteScroll
								dataLength={scrollValResult}
								next={fetchMoreDataResult}
								hasMore={hasMoreresult}
								loader={<h4>Loading...</h4>}
								endMessage={
									<p style={{ textAlign: 'center' }}>
										<b>No More Data</b>
									</p>
								}>
								{result2.map((item, index) => {
									return index < scrollValResult ? (
										<CardFlightReturn
											item={item}
											index={index}
											selectedReturn={selectedReturn}
										/>
									) : (
										''
									);
								})}
							</InfiniteScroll>
						) : filterData5 && filterData5.length > 0 ? (
							<InfiniteScroll
								dataLength={scrollVal2}
								next={fetchMoreData2}
								hasMore={hasMorefilterData2}
								loader={<h4>Loading...</h4>}
								endMessage={
									<p style={{ textAlign: 'center' }}>
										<b>No More Data</b>
									</p>
								}>
								{filterData5.map((item, index) => {
									return index < scrollVal2 ? (
										<CardFlightReturn
											item={item}
											index={index}
											selectedReturn={selectedReturn}
										/>
									) : (
										''
									);
								})}
								{/* <></> */}
							</InfiniteScroll>
						) : (
							<>
								<div
									style={{
										padding: '30px 15px',
										background: 'white',
										borderBottom: '1px solid #e6e6e6',
										textAlign: 'center',
									}}>
									<img src={flightnotfound}></img>
									<p style={{ fontSize: '24px', textAlign: 'center' }}>
										No Flight Found
									</p>
								</div>
							</>
							// flightreturn &&
							// flightreturn.data &&
							// flightreturn.data.Response &&
							// flightreturn.data.Response.Results[1].length > 0 &&
							// flightreturn.data.Response.Results[1].map((item, index) => {
							// 	return <CardFlightReturn item={item} index={index} />;
							// })
						)}
					</Grid>
				</Grid>
				{/* </Container> */}
			</Box>
			{loading
				? ''
				: filterData4 &&
				  filterData5 && (
						<Box
							style={{
								position: 'fixed',
								bottom: 0,
								left: 0,
								right: 0,
								padding: '10px 0',
								background: 'black',
								color: '#bbb',
								zIndex: 9,
							}}>
							<Container>
								<Grid container>
									<Grid item xs={1} alignItems='center'>
										<Box display='flex'>
											<span
												style={{
													color: 'white',
													fontFamily: 'Josefin Sans, sans-serif',
													fontWeight: 500,
												}}>
												Your Selection
											</span>
											<div
												style={{
													borderLeft: '3px solid grey',
													height: 80,
													marginLeft: 10,
												}}></div>
										</Box>
									</Grid>
									<Grid item xs={4} style={{ padding: 5 }}>
										<Box
											display='flex'
											justifyContent='space-between'
											style={{ paddingLeft: 5 }}>
											<Box>
												{' '}
												<Box>
													<span
														style={{
															color: 'white',
															fontFamily: 'Josefin Sans, sans-serif',
														}}>
														Onwards
													</span>
												</Box>
												<Box mt={'5px'}>
													{loading ? (
														<Skeleton />
													) : (
														<img
															src={`https://nitish.musafirbazar.com/static/media/${
																selectedonward && selectedonward.length === 1
																	? selectedonward &&
																	  selectedonward[0].Airline_Code
																		? selectedonward[0].Airline_Code
																		: selectedonward[0].AirlineCode
																		? selectedonward[0].AirlineCode
																		: ''
																	: ''
															}.gif`}
															width='50px'
															height='25px'></img>
													)}
												</Box>
											</Box>
											<Box
												display='flex'
												justifyContent='space-between'
												ml={'5px'}>
												<Box>
													<Box display={'flex'}>
														<BodyText
															three
															textStyle={{ color: 'white', fontSize: 12 }}>
															{selectedonward && selectedonward.length === 1
																? selectedonward[0].Airline_Code
																	? selectedonward[0].Segments[0].Airline_Name
																	: selectedonward[0].AirlineCode
																	? selectedonward[0].Segments[0]
																			.slice(0, 1)
																			.map((i) => {
																				return i.Airline.AirlineName;
																			})
																	: ''
																: ''}
														</BodyText>
														<div
															style={{
																borderLeft: '2px solid grey',
																height: 20,
																marginLeft: 10,
																marginRight: 10,
															}}></div>
														<BodyText
															three
															textStyle={{ color: 'white', fontSize: 12 }}>
															{' '}
															{selectedonward && selectedonward.length === 1
																? selectedonward[0].Airline_Code
																	? selectedonward[0].Airline_Code
																	: selectedonward[0].AirlineCode
																	? selectedonward[0].AirlineCode
																	: ''
																: ''}
															-
															{selectedonward && selectedonward.length === 1
																? selectedonward[0].Airline_Code
																	? selectedonward[0].Flight_Numbers.substr(
																			0,
																			8
																	  )
																	: selectedonward[0].AirlineCode
																	? selectedonward[0].Segments[0]
																			.slice(0, 1)
																			.map((i) => {
																				return i.Airline.FlightNumber;
																			})
																	: ''
																: ''}
														</BodyText>
													</Box>
													<Box
														display='flex'
														justifyContent='space-around'
														mt={'10px'}>
														<span style={{ color: 'white' }}>
															{selectedonward && selectedonward.length === 1
																? selectedonward[0].Airline_Code
																	? selectedonward[0].Segments[0].Departure_DateTime.substr(
																			11,
																			5
																	  )
																	: selectedonward[0].Segments[0].map((i) => {
																			return i.Origin.DepTime.substr(11, 5);
																	  })
																: ''}
														</span>
														<span style={{ color: 'white' }}>
															{selectedonward && selectedonward.length === 1
																? selectedonward[0].Airline_Code
																	? selectedonward[0].Segments.length === 1
																		? selectedonward[0].Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: selectedonward[0].Segments.length === 2
																		? selectedonward[0].Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: selectedonward[0].Segments.length === 3
																		? selectedonward[0].Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: ''
																	: selectedonward[0].Segments[0].length == 3
																	? selectedonward[0].Segments[0]
																			.filter((i, index) => index === 2)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: selectedonward[0].Segments[0].length == 2
																	? selectedonward[0].Segments[0]
																			.filter((i, index) => index === 1)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: selectedonward[0].Segments[0].length == 1
																	? selectedonward[0].Segments[0]
																			.filter((i, index) => index === 0)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: ''
																: ''}
														</span>
													</Box>
												</Box>
											</Box>
											<Box>
												<BodyText three textStyle={{ fontSize: 14 }}>
													{selectedonward && selectedonward.length === 1
														? selectedonward[0].Airline_Code
															? selectedonward[0].TravelDate
															: ''
														: ''}
												</BodyText>
												<TitleText
													four
													textStyle={{
														color: 'white',
														marginLeft: 5,
														marginTop: 5,
														fontSize: 16,
													}}>
													₹ {''}
													{selectedonward && selectedonward.length === 1
														? selectedonward[0].Airline_Code
															? Number(
																	Math.round(
																		selectedonward[0].Fares[0].FareDetails[0]
																			.Basic_Amount
																	)
															  ) +
															  Number(
																	Math.round(
																		selectedonward[0].Fares[0].FareDetails[0]
																			.AirportTax_Amount
																	)
															  ) -
															  Number(
																	Math.round(
																		selectedonward[0].Fares[0].FareDetails[0]
																			.Net_Commission
																	)
															  ) +
															  Number(
																	Math.round(
																		true
																			? 0
																			: selectedonward[0].Fares[0]
																					.FareDetails[0].agentMarkup
																	)
															  ) +
															  Number(
																	Math.round(
																		selectedonward[0].Fares[0].FareDetails[0]
																			.TDS
																	)
															  )
															: selectedonward[0].AirlineCode
															? Number(
																	Math.round(selectedonward[0].Fare.BaseFare)
															  ) +
															  Number(Math.round(selectedonward[0].Fare.Tax)) +
															  Number(
																	Math.round(selectedonward[0].Fare.TdsOnPLB)
															  ) +
															  Number(
																	Math.round(
																		true
																			? 0
																			: selectedonward[0].Fare.agentMarkup
																	)
															  ) -
															  Number(
																	Math.round(
																		selectedonward[0].Fare.CommissionEarned
																	)
															  ) -
															  Number(
																	Math.round(selectedonward[0].Fare.PLBEarned)
															  ) +
															  Number(
																	Math.round(
																		selectedonward[0].Fare.TdsOnCommission
																	)
															  )
															: ''
														: ''}
												</TitleText>
											</Box>
											<div
												style={{
													borderLeft: '3px solid grey',
													height: 80,
												}}></div>
										</Box>
									</Grid>
									<Grid item xs={4} style={{ padding: 5 }}>
										<Box
											display='flex'
											justifyContent='space-between'
											style={{ paddingLeft: 5 }}>
											<Box>
												{' '}
												<Box>
													<span
														style={{
															color: 'white',
															fontFamily: 'Josefin Sans, sans-serif',
														}}>
														Return
													</span>
												</Box>
												<Box mt={'5px'}>
													{loading ? (
														<Skeleton />
													) : (
														<img
															src={`https://nitish.musafirbazar.com/static/media/${
																selectedReturn && selectedReturn.length === 1
																	? selectedReturn &&
																	  selectedReturn[0].Airline_Code
																		? selectedReturn[0].Airline_Code
																		: selectedReturn[0].AirlineCode
																		? selectedReturn[0].AirlineCode
																		: ''
																	: ''
															}.gif`}
															width='50px'
															height='25px'></img>
													)}
												</Box>
											</Box>
											<Box
												display='flex'
												justifyContent='space-between'
												ml={'5px'}>
												<Box>
													<Box display={'flex'}>
														<BodyText
															three
															textStyle={{ color: 'white', fontSize: 12 }}>
															{selectedReturn && selectedReturn.length === 1
																? selectedReturn[0].Airline_Code
																	? selectedReturn[0].Segments[0].Airline_Name
																	: selectedReturn[0].AirlineCode
																	? selectedReturn[0].Segments[0]
																			.slice(0, 1)
																			.map((i) => {
																				return i.Airline.AirlineName;
																			})
																	: ''
																: ''}
														</BodyText>
														<div
															style={{
																borderLeft: '2px solid grey',
																height: 20,
																marginLeft: 10,
																marginRight: 10,
															}}></div>
														<BodyText
															three
															textStyle={{ color: 'white', fontSize: 12 }}>
															{' '}
															{selectedReturn && selectedReturn.length === 1
																? selectedReturn[0].Airline_Code
																	? selectedReturn[0].Airline_Code
																	: selectedReturn[0].AirlineCode
																	? selectedReturn[0].AirlineCode
																	: ''
																: ''}
															-
															{selectedReturn && selectedReturn.length === 1
																? selectedReturn[0].Airline_Code
																	? selectedReturn[0].Flight_Numbers.substr(
																			0,
																			8
																	  )
																	: selectedReturn[0].AirlineCode
																	? selectedReturn[0].Segments[0]
																			.slice(0, 1)
																			.map((i) => {
																				return i.Airline.FlightNumber;
																			})
																	: ''
																: ''}
														</BodyText>
													</Box>
													<Box
														display='flex'
														justifyContent='space-around'
														mt={'10px'}>
														<span style={{ color: 'white' }}>
															{selectedReturn && selectedReturn.length === 1
																? selectedReturn[0].Airline_Code
																	? selectedReturn[0].Segments[0].Departure_DateTime.substr(
																			11,
																			5
																	  )
																	: selectedReturn[0].Segments[0].map((i) => {
																			return i.Origin.DepTime.substr(11, 5);
																	  })
																: ''}
														</span>
														<span style={{ color: 'white' }}>
															{selectedReturn && selectedReturn.length === 1
																? selectedReturn[0].Airline_Code
																	? selectedReturn[0].Segments.length === 1
																		? selectedReturn[0].Segments.filter(
																				(i, index) => index === 0
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: selectedReturn[0].Segments.length === 2
																		? selectedReturn[0].Segments.filter(
																				(i, index) => index === 1
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: selectedReturn[0].Segments.length === 3
																		? selectedReturn[0].Segments.filter(
																				(i, index) => index === 2
																		  ).map((it) => {
																				return it.Arrival_DateTime.substr(
																					11,
																					5
																				);
																		  })
																		: ''
																	: selectedReturn[0].Segments[0].length == 3
																	? selectedReturn[0].Segments[0]
																			.filter((i, index) => index === 2)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: selectedReturn[0].Segments[0].length == 2
																	? selectedReturn[0].Segments[0]
																			.filter((i, index) => index === 1)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: selectedReturn[0].Segments[0].length == 1
																	? selectedReturn[0].Segments[0]
																			.filter((i, index) => index === 0)
																			.map((i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			})
																	: ''
																: ''}
														</span>
													</Box>
												</Box>
											</Box>
											<Box>
												<BodyText three textStyle={{ fontSize: 14 }}>
													{selectedReturn && selectedReturn.length === 1
														? selectedReturn[0].Airline_Code
															? selectedReturn[0].TravelDate
															: ''
														: ''}
												</BodyText>
												<TitleText
													four
													textStyle={{
														color: 'white',
														marginLeft: 5,
														marginTop: 5,
														fontSize: 16,
													}}>
													₹ {''}
													{selectedReturn && selectedReturn.length === 1
														? selectedReturn[0].Airline_Code
															? Number(
																	Math.round(
																		selectedReturn[0].Fares[0].FareDetails[0]
																			.Basic_Amount
																	)
															  ) +
															  Number(
																	Math.round(
																		selectedReturn[0].Fares[0].FareDetails[0]
																			.AirportTax_Amount
																	)
															  ) -
															  Number(
																	Math.round(
																		selectedReturn[0].Fares[0].FareDetails[0]
																			.Net_Commission
																	)
															  ) +
															  Number(
																	Math.round(
																		true
																			? 0
																			: selectedReturn[0].Fares[0]
																					.FareDetails[0].agentMarkup
																	)
															  ) +
															  Number(
																	Math.round(
																		selectedReturn[0].Fares[0].FareDetails[0]
																			.TDS
																	)
															  )
															: selectedReturn[0].AirlineCode
															? Number(
																	Math.round(selectedReturn[0].Fare.BaseFare)
															  ) +
															  Number(Math.round(selectedReturn[0].Fare.Tax)) +
															  Number(
																	Math.round(selectedReturn[0].Fare.TdsOnPLB)
															  ) +
															  Number(
																	Math.round(
																		true
																			? 0
																			: selectedReturn[0].Fare.agentMarkup
																	)
															  ) -
															  Number(
																	Math.round(
																		selectedReturn[0].Fare.CommissionEarned
																	)
															  ) -
															  Number(
																	Math.round(selectedReturn[0].Fare.PLBEarned)
															  ) +
															  Number(
																	Math.round(
																		selectedReturn[0].Fare.TdsOnCommission
																	)
															  )
															: ''
														: ''}
												</TitleText>
											</Box>
											<div
												style={{
													borderLeft: '3px solid grey',
													height: 80,
												}}></div>
										</Box>
									</Grid>
									<Grid item xs={3} style={{ padding: 5 }}>
										<Box display='flex' justifyContent='space-between'>
											<Box>
												<span
													style={{
														color: 'white',
														marginLeft: 5,
														fontFamily: 'Josefin Sans, sans-serif',
														fontWeight: 500,
													}}>
													Total Amount
												</span>

												<Box>
													<span
														style={{
															color: '#f56d6d',
															marginLeft: 5,
															fontSize: 20,
														}}>
														{`Rs ${
															Number(
																selectedonward && selectedonward.length === 1
																	? selectedonward[0].Airline_Code
																		? Number(
																				Math.round(
																					selectedonward[0].Fares[0]
																						.FareDetails[0].Basic_Amount
																				)
																		  ) +
																		  Number(
																				Math.round(
																					selectedonward[0].Fares[0]
																						.FareDetails[0].AirportTax_Amount
																				)
																		  ) -
																		  Number(
																				Math.round(
																					selectedonward[0].Fares[0]
																						.FareDetails[0].Net_Commission
																				)
																		  ) +
																		  Number(
																				Math.round(
																					true
																						? 0
																						: selectedonward[0].Fares[0]
																								.FareDetails[0].agentMarkup
																				)
																		  ) +
																		  Number(
																				Math.round(
																					selectedonward[0].Fares[0]
																						.FareDetails[0].TDS
																				)
																		  )
																		: selectedonward[0].AirlineCode
																		? Number(
																				Math.round(
																					selectedonward[0].Fare.BaseFare
																				)
																		  ) +
																		  Number(
																				Math.round(selectedonward[0].Fare.Tax)
																		  ) +
																		  Number(
																				Math.round(
																					selectedonward[0].Fare.TdsOnPLB
																				)
																		  ) +
																		  Number(
																				Math.round(
																					true
																						? 0
																						: selectedonward[0].Fare.agentMarkup
																				)
																		  ) -
																		  Number(
																				Math.round(
																					selectedonward[0].Fare
																						.CommissionEarned
																				)
																		  ) -
																		  Number(
																				Math.round(
																					selectedonward[0].Fare.PLBEarned
																				)
																		  ) +
																		  Number(
																				Math.round(
																					selectedonward[0].Fare.TdsOnCommission
																				)
																		  )
																		: ''
																	: ''
															) +
															Number(
																selectedReturn && selectedReturn.length === 1
																	? selectedReturn[0].Airline_Code
																		? Number(
																				Math.round(
																					selectedReturn[0].Fares[0]
																						.FareDetails[0].Basic_Amount
																				)
																		  ) +
																		  Number(
																				Math.round(
																					selectedReturn[0].Fares[0]
																						.FareDetails[0].AirportTax_Amount
																				)
																		  ) -
																		  Number(
																				Math.round(
																					selectedReturn[0].Fares[0]
																						.FareDetails[0].Net_Commission
																				)
																		  ) +
																		  Number(
																				Math.round(
																					true
																						? 0
																						: selectedReturn[0].Fares[0]
																								.FareDetails[0].agentMarkup
																				)
																		  ) +
																		  Number(
																				Math.round(
																					selectedReturn[0].Fares[0]
																						.FareDetails[0].TDS
																				)
																		  )
																		: selectedReturn[0].AirlineCode
																		? Number(
																				Math.round(
																					selectedReturn[0].Fare.BaseFare
																				)
																		  ) +
																		  Number(
																				Math.round(selectedReturn[0].Fare.Tax)
																		  ) +
																		  Number(
																				Math.round(
																					selectedReturn[0].Fare.TdsOnPLB
																				)
																		  ) +
																		  Number(
																				Math.round(
																					true
																						? 0
																						: selectedReturn[0].Fare.agentMarkup
																				)
																		  ) -
																		  Number(
																				Math.round(
																					selectedReturn[0].Fare
																						.CommissionEarned
																				)
																		  ) -
																		  Number(
																				Math.round(
																					selectedReturn[0].Fare.PLBEarned
																				)
																		  ) +
																		  Number(
																				Math.round(
																					selectedReturn[0].Fare.TdsOnCommission
																				)
																		  )
																		: ''
																	: ''
															)
														}`}
													</span>
												</Box>
											</Box>

											{loading ? (
												<Skeleton width='100px' height='50px' />
											) : (
												<Box
													onClick={() => {
														history.push({
															pathname: '/summaryflight',
															state: {
																orderID: orderID.result,
																flightData:
																	resultSelection.length == 1
																		? resultSelection
																		: onward.length == 1
																		? onward
																		: '',
																selectedonward:
																	selectedonward.length == 1
																		? selectedonward
																		: '',
																selectedReturn:
																	selectedReturn.length == 1
																		? selectedReturn
																		: '',

																Returnflight:
																	resultRSelection.length == 1
																		? resultRSelection
																		: returnD.length == 1
																		? returnD
																		: '',
																returnBody: location.state.returnBody,
																ID:
																	flightreturn &&
																	flightreturn.result &&
																	flightreturn.result.Response &&
																	flightreturn.result.Response.TraceId,
																IDTBO:
																	flightreturn &&
																	flightreturn.result &&
																	flightreturn.result.Response &&
																	flightreturn.result.Response.TraceId,
																IDEtrav:
																	roundTripEtrav &&
																	roundTripEtrav.result &&
																	roundTripEtrav.result.Search_Key,
															},
														});
													}}
													textAlign='center'
													style={{
														color: 'white',
														background: 'rgb(239, 51, 57)',
														padding: '16px 18px',
														borderRadius: 8,
														cursor: 'pointer',
														fontFamily: 'Josefin Sans, sans-serif',
														fontWeight: 500,
														boxShadow: '3px 3px 12px -6px rgb(0 0 0 / 70%)',
													}}>
													<TitleText>Book Now</TitleText>
												</Box>
											)}
										</Box>
									</Grid>
								</Grid>
							</Container>
						</Box>
				  )}
			<FlightDetailModal />
			<Drawers />
			<Login />
		</>
	);
};

export default RoundTrip;
